import { render, staticRenderFns } from "./MaterialRecommendation.vue?vue&type=template&id=12ed45e7&scoped=true&"
import script from "./MaterialRecommendation.vue?vue&type=script&lang=ts&"
export * from "./MaterialRecommendation.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialRecommendation.vue?vue&type=style&index=0&id=12ed45e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed45e7",
  null
  
)

export default component.exports